<template>
    <div class="sr-filter-buttons">
        <SrButton v-if="applicable" :disabled="!hasChanges" class="apply-button" text @click="emitApplyEvent">
            {{ applyButtonText }}
        </SrButton>

        <SrButton v-if="clearable" :disabled="!hasValue" class="clear-button" text @click="emitClearEvent">
            {{ clearButtonText }}
        </SrButton>

        <SrButton v-if="saveable" :disabled="!isSaveable" class="save-button" text @click="emitSaveEvent">
            {{ saveButtonText }}
        </SrButton>
    </div>
</template>

<script>
import { SrButton } from '../SrButton';

export default {
    name: 'SrFilterItem',
    components: {
        SrButton,
    },
    props: {
        clearable: Boolean,
        applicable: Boolean,
        saveable: Boolean,
        hasChanges: Boolean,
        hasValue: Boolean,
        isApplied: Boolean,
        isSaveable: Boolean,
        applyButtonText: {
            type: String,
            default: 'Apply',
        },
        clearButtonText: {
            type: String,
            default: 'Clear',
        },
        saveButtonText: {
            type: String,
            default: 'Save',
        },
    },
    methods: {
        emitApplyEvent() {
            this.$emit('apply');
        },
        emitSaveEvent() {
            this.$emit('save');
        },
        emitClearEvent() {
            this.$emit('clear');
        },
    },
};
</script>
